import { useGetFetureTogglesQuery } from './utils-api';

const getFeatureToggleStatus = (data, toggleLabel) => data?.data?.find((item) => item.name === toggleLabel)?.status;

export function useFeatureToggle() {
  const { data, isLoading } = useGetFetureTogglesQuery({});

  const IS_PDF_V2 = isLoading ? null : getFeatureToggleStatus(data, 'IS_PDF_V2');
  const ADV_VULN_SEARCH_V2 = getFeatureToggleStatus(data, 'ADV_VULN_SEARCH_V2');
  const IS_LENS_FONT = getFeatureToggleStatus(data, 'IS_LENS_FONT');
  const COMPENSATION_HEALTHCHECK = getFeatureToggleStatus(data, 'COMPENSATION_HEALTHCHECK');
  const GOVERNANCE_AUDITOR_FEES_AND_MATERIAL_WEAKNESSES = getFeatureToggleStatus(
    data,
    'GOVERNANCE_AUDITOR_FEES_AND_MATERIAL_WEAKNESSES',
  );
  const GOVERNANCE_RELATED_PARTY_TRANSACTIONS = getFeatureToggleStatus(data, 'GOVERNANCE_RELATED_PARTY_TRANSACTIONS');
  const VOTING_INVESTOR_VOTING_RATIONALE = getFeatureToggleStatus(data, 'VOTING_INVESTOR_VOTING_RATIONALE');

  return {
    IS_PDF_V2,
    ADV_VULN_SEARCH_V2,
    IS_LENS_FONT,
    COMPENSATION_HEALTHCHECK,
    GOVERNANCE_AUDITOR_FEES_AND_MATERIAL_WEAKNESSES,
    GOVERNANCE_RELATED_PARTY_TRANSACTIONS,
    VOTING_INVESTOR_VOTING_RATIONALE,
    isLoadingFeatureToggles: isLoading,
  };
}
